<div class="card" id="contact-assocaitions">
    <div class="card-body">
        <div class="title-bar">
            <h2 class="card-title">Associations</h2>
        </div>
    </div>
    <ul class="list-group list-group-flush contact-associations-list">
        @if ((!associations || (associations.length <= 0))) { 
            <li class="list-group-item">No relatives, friends, companies or other associations at this time.</li>
        }

        @for (associate of associations; track associate) {
            <li class="list-group-item">
                <div class="text-truncate" [routerLink]="['/contacts/', associate.contactId]">
                    <p class="title">{{associate.name}}</p>
                    @if (associate.city) {
                        <p class="subtitle">{{associate.city | titlecase}}, {{associate.state}} {{associate.zipCode}}</p>
                    }
                    <p class="subtitle">{{associate.relationship}}</p>
                </div>
                <div class="link-bar">
                    @if (associate.comms && associate.isIndividual) {
                        <a href="mailto:{{associate.comms}}" class="card-link"><span class="material-icons">email</span></a>
                    }
                    @if (associate.comms && !associate.isIndividual) {
                        <a href="{{associate.comms}}" class="card-link" target="_blank"><span class="material-icons">link</span></a>
                    }
                    @if (associate.phone) {
                        <a href="tel://{{associate.phone}}" class="card-link"><span class="material-icons">phone</span></a>
                    }
                </div>
            </li>
        }
    </ul>
</div>